import actionTypes from './actionTypes';
import getActionCreator from '../libs/getActionCreator';

// eslint-disable-next-line import/prefer-default-export
export const signUp = getActionCreator(actionTypes.SIGN_UP);
export const signIn = getActionCreator(actionTypes.SIGN_IN);
export const refresh = getActionCreator(actionTypes.REFRESH);
export const confirmEmail = getActionCreator(actionTypes.CONFIRM_EMAIL);

export const logout = () => ({
  type: actionTypes.LOGOUT,
});
